<div>

  <h2>{{pageData?.error?.heading}}</h2>

  <!-- Alert callout -->
  <!-- <div *ngIf="ngForm.submitted && ngForm.invalid" class="callout alert " role="alert" aria-labelledby="calloutHeadingAlert"> -->
  <div class="callout alert " role="alert" aria-labelledby="calloutHeadingAlert">
      <div class="callout__heading">
          <h2 id="calloutHeadingAlert">{{pageData?.error?.information}}</h2>
      </div>
      <div class="callout__content">
          <p>{{pageData?.error?.message}}</p>
      </div>
  </div>
  <br>

  <div>
    <b>{{pageData?.error?.ticketNumber}} {{ticketNumber}}</b>
  </div>
  <br>

  <!-- <div class="list-style standard-margin-bottom"> -->
  <div class="error-dialog-info-section">
    <!-- <h2 id="refundHeading">If it's been more than 7 days, you can:</h2> -->
    <p>{{pageData?.error?.moreThan7Days}}</p>
    <p><a href="https://prefunds.aa.com/refunds/" class="link-blue" target="_blank" rel="noopener noreferrer">{{pageData?.error?.resubmitYourRequest}} <span class="icon-newpage" aria-hidden="true"></span>
        <span class="show-for-sr">, {{pageData?.error?.newWindowMessage}}</span></a></p>
    <p><a href="https://{{this.getHostname()}}/i18n/customer-service/contact-american/receipts-and-refunds.jsp" class="link-blue" target="_blank" rel="noopener noreferrer">{{pageData?.error?.contactRefunds}} <span class="icon-newpage" aria-hidden="true"></span>
      <span class="show-for-sr">, {{pageData?.error?.newWindowMessage}}</span></a></p>
    </div>

</div>